import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { SapEccLinkedService } from 'app/model/linkedservice/sap-ecc.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sapecc.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.SapEcc_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.SapEcc_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: SapEccLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SapEccResourceDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
